import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

import { useOrderManager } from "~/managers/use-order-manager";
import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useCartStore } from "~/stores/use-cart-store";
import { useOrderStore } from "~/stores/use-order-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";

export default function NoTableSelectedDialog() {
  const { noTableSelectedDialogOpen, setNoTableSelectedDialogOpen, items } =
    useCartStore();

  const { setUnsavedChanges } = useUnsavedChanges();

  const { setTransferItems } = useOrderStore();

  const { startTransfer } = useOrderManager();

  const handleTransfer = () => {
    setTransferItems(items);
    startTransfer();
    setNoTableSelectedDialogOpen(false);
    setUnsavedChanges({
      isDirty: false,
    });
  };

  return (
    <Dialog
      open={noTableSelectedDialogOpen}
      onOpenChange={setNoTableSelectedDialogOpen}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>No table selected</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-4">
          <div className="flex flex-col gap-4">
            <Button onClick={handleTransfer}>Transfer to table</Button>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
